module.exports = __webpack_public_path__ + "img/pdf.b01b39c2.svg";